/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from "react";
import { useGLTF, useTexture } from "@react-three/drei";
import { useControls } from "leva";
import { DoubleSide, FrontSide, NoColorSpace } from "three";
import HoloSticker from "./HoloSticker";
import ToyButton from "./ToyButton";

export default function RingTossModel(props) {
    const { nodes } = useGLTF("./WaterRingGame3.glb");
    const [normalMap, roughnessMap] = useTexture([
        "./NormalMap.png",
        "./RoughnessMap.png",
    ]);
    const colors = useControls("Colors", {
        Body: "#d5113d",
        CrossBtn: "#1d6fd8",
        PlusBtn: "#bac400",
        Fixtures: "#8dbaf5",
        WaterContainer: "#c5e8f5",
    });

    normalMap.flipY = false;
    roughnessMap.flipY = false;
    normalMap.colorSpace = NoColorSpace;
    roughnessMap.colorSpace = NoColorSpace;

    return (
        <group {...props} dispose={null}>
            <mesh castShadow receiveShadow geometry={nodes.Body.geometry}>
                <meshStandardMaterial
                    color={colors.Body}
                    roughness={1}
                    metalness={0.1}
                    normalMap={normalMap}
                    roughnessMap={roughnessMap}
                />
            </mesh>
            <ToyButton
                side="cross"
                geometry={nodes.CrossBtn.geometry}
                color={colors.CrossBtn}
                restPosition={[-0.163, -0.925, -0.55]}
                restRotation={[Math.PI / 4, 0, 0]}
                normalMap={normalMap}
                roughnessMap={roughnessMap}
                hotkey="KeyQ"
            />
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Fixtures.geometry}
                position={[0, -0.473, 0]}
                raycast={() => null}
            >
                <meshPhongMaterial color={colors.Fixtures} side={FrontSide} />
            </mesh>
            {/* on the flat front panel, midway between the two buttons */}
            <HoloSticker
                artwork="./littlewhale.svg"
                position={[-0.1655, -0.9252, 0]}
                rotation={[0, -Math.PI / 2, 0]}
            />
            <ToyButton
                side="plus"
                geometry={nodes.PlusBtn.geometry}
                color={colors.PlusBtn}
                restPosition={[-0.163, -0.925, 0.55]}
                normalMap={normalMap}
                roughnessMap={roughnessMap}
                hotkey="KeyE"
            />
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.WaterContainer.geometry}
                raycast={() => null}
            >
                <meshStandardMaterial
                    color={colors.WaterContainer}
                    roughness={0.05}
                    metalness={0.5}
                    transparent
                    opacity={0.28}
                    depthWrite={false}
                    side={DoubleSide}
                />
            </mesh>
        </group>
    );
}

useGLTF.preload("/WaterRingGame3.glb");
useTexture.preload("./NormalMap.png");
useTexture.preload("./RoughnessMap.png");
